import { BG_TASK_TYPES } from "helpers/bgTasks";
import { workloadStatusesEnum } from "helpers/enums";
import React from "react";
import RunningBgTask from "./show/runningBgTask";

/** Preserve the report runtime prerequisites for both dedicated pages and the generic report view. */
export default function ReportTaskGate({ organizationTimezone, bgTasks, taskKey, back, removeBgTask, children }) {
    if (!organizationTimezone.utcOffset?.length) {
        return null;
    }
    const active = Object.values(bgTasks).find((task) =>
        [BG_TASK_TYPES.GenerateReport, BG_TASK_TYPES.DownloadGeneratedReport].includes(task.taskType),
    );
    if ([workloadStatusesEnum.NotStarted, workloadStatusesEnum.Running].includes(active?.status)) {
        return <RunningBgTask back={back} removeBgTask={removeBgTask} activeBgTask={active} />;
    }
    const completedKey =
        active?.status === workloadStatusesEnum.Completed && active.taskType === BG_TASK_TYPES.GenerateReport
            ? active.key
            : undefined;
    return children(taskKey || completedKey);
}
